// extracted by mini-css-extract-plugin
export default {"search":"Search_search__ZHv6n","icon":"Search_icon__QVLhE"};